import {
  Tabs as MantineTabs,
  type TabsProps as MantineTabsProps,
} from '@mantine/core';
import type { CoreComponentProps } from '../../types';
import { useShouldRender } from '../../../hooks/useShouldRender';

export type TabsProps = CoreComponentProps<MantineTabsProps, 'div'>;

function TabsRoot({ testId, view = 'all', ...rest }: TabsProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineTabs data-testid={testId} {...rest} />;
}

export const Tabs = Object.assign(TabsRoot, {
  List: MantineTabs.List,
  Tab: MantineTabs.Tab,
  Panel: MantineTabs.Panel,
});
